module.exports = __webpack_public_path__ + "static/img/trialContent.0bef455.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/trialContent.png
// module id = 2GzR
// module chunks = 0